
import Sizes from '../../../../../style_helpers/sizes'

export default {
  loader: {
    base: {
      position: 'absolute',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      display: 'block',
      height: Sizes(1),
      lineHeight: 'normal',
      margin: 'auto',
      textAlign: 'center'
    },

    // Longhand use of animation is intentional. Shorthand gets ignored by React inline style.
    rect: (colour) => {
      return {
        display: 'inline-block',
        width: '5px',
        height: '100%',
        margin: '0px 2px',
        backgroundColor: colour,
        animationName: 'stretch',
        animationDuration: '1.2s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite'
      }
    },

    rect2: {
      animationDelay: '-1.1s'
    },

    rect3: {
      animationDelay: '-1s'
    },

    rect4: {
      animationDelay: '-0.9s'
    }
  }
}
